<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.conectasusUnidades"
                    :validations="validations.conectasusUnidade"
                    @change="handleConectaSusUnidadeChange"
                    label="Unidade (ConectaSUS)"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.conectasusUnidadeId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="form.conectasusInfraestruturas"
                    :validations="validations.conectasusInfraestrutura"
                    label="Local de atendimento (ConectaSUS)"
                    show-default-option
                    text-field="nome"
                    v-model="model.conectasusInfraestruturaId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                conectasusUnidade: {required: true},
                conectasusInfraestrutura: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            laboratorio: this.getConectaSusRepository('webService.laboratorio.cliente.laboratorio'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.laboratorio.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleConectaSusUnidadeChange() {
            this.form.conectasusInfraestruturas = []
            this.model.conectasusInfraestruturaId = null

            this.setLoading()

            this.repositories.laboratorio.list({
                listar: 'conectasus-infraestruturas',
                conectasus_unidade_id: this.model.conectasusUnidadeId,
            })
                .then(response => {
                    this.form.conectasusInfraestruturas = response.data.conectasusInfraestruturas

                    if (this.form.conectasusInfraestruturas.length === 1) {
                        this.model.conectasusInfraestruturaId = this.form.conectasusInfraestruturas[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        conectasusInfraestruturaId: this.model.conectasusInfraestruturaId,
                    }

                    this.repositories.laboratorio.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
}
</script>